// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".o-menu__club-select[data-v-68baa30b] .v-list-group__header__append-icon:last-of-type:not(:only-child){margin:0;min-width:0}.o-menu__withIcon[data-v-68baa30b] .v-list-item__icon{margin-left:8px;margin-right:26px}.o-menu__withIcon[data-v-68baa30b] .v-avatar{margin-right:18px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
